import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  Container,
  Navbar,
  Nav,
  Button,
  Row,
  Col,
  Card,
} from "react-bootstrap";
import {
  FaPhone,
  FaMapMarkerAlt,
  FaFax,
  FaCalendarCheck,
} from "react-icons/fa";
import { QRCodeSVG } from "qrcode.react";

export default function App() {
  return (
    <div style={styles.page}>
      <div style={styles.overlay}>
        <SiteNavbar />
        <Hero />
        <Doctors />
        <PatientForm />
        <Appointment />
        <Contact />
        <Footer />
      </div>
    </div>
  );
}

const styles = {
  page: {
    backgroundImage: "url('background.png')",
    backgroundSize: "cover",
    backgroundPosition: "center",
    minHeight: "100vh",
  },
  overlay: {
    background: "linear-gradient(rgba(0,0,0,0.7), rgba(13,110,253,0.5))",
    minHeight: "100vh",
    color: "white",
  },
};

function SiteNavbar() {
  return (
    <Navbar expand="lg" style={{ background: "rgba(0,0,0,0.6)" }} sticky="top">
      <Container>
        <Navbar.Brand className="text-white fw-bold">
          <img src="/logo.png" className="w-25" alt="logo" />
          <span className="d-none d-sm-inline"> Colborne Medicare</span>
        </Navbar.Brand>
        <Navbar.Toggle className="bg-white border-0 opacity-75" />
        <Navbar.Collapse>
          <Nav className="ms-auto">
            <Nav.Link href="#home" className="text-white">
              Home
            </Nav.Link>
            <Nav.Link href="#doctors" className="text-white">
              Doctors
            </Nav.Link>
            <Nav.Link href="#patient_forms" className="text-white">
              Patient Forms
            </Nav.Link>
            <Nav.Link href="#appointment" className="text-white">
              Appointment
            </Nav.Link>
            <Nav.Link href="#contact" className="text-white">
              Contact
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

function Hero() {
  return (
    <section id="home" className="text-center py-5">
      <Container>
        <h1 className="display-4 fw-bold">Your Health, Our Priority</h1>
        <p className="lead">Professional and trusted medical care</p>
        <Button style={styles.button} href="#appointment">
          <FaCalendarCheck /> Book Appointment
        </Button>
      </Container>
    </section>
  );
}

function Doctors() {
  return (
    <Container className="py-5" id="doctors">
      <h2 className="text-center mb-4">Our Doctors</h2>
      <Row>
        {["Dr. A. Imran", "Dr. Joie Martin","Dr. Rabiya Niaz"].map((doc, i) => (
          <Col md={6} key={i}>
            <Card style={styles.card} className="mb-4">
              <Card.Body>
                <Card.Title>{doc}</Card.Title>
                <Card.Text>M.D., C.C.F.P</Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
}

function Appointment() {
  const bookingURL = "https://ocean.tips/drimran-ob";

  return (
    <section id="appointment" className="text-center py-5">
      <Container>
        <h2>Book Appointment</h2>
        <p>Scan QR or click below</p>

        <div style={styles.qrBox}>
          <QRCodeSVG value={bookingURL} size={170} />
        </div>

        <div>
          <Button style={styles.button} href={bookingURL} target="_blank">
            Book Now
          </Button>
        </div>
      </Container>
    </section>
  );
}

function Contact() {
  return (
    <Container className="py-5" id="contact">
      <h2 className="text-center mb-4">Contact Us</h2>
      <Row>
        <Col md={6}>
          <p>
            <FaMapMarkerAlt /> 358 Oxford Street East, London
          </p>
          <p>
            <FaPhone /> 519 438 0002
          </p>
          <p>
            <FaFax /> 519 438 0888
          </p>
          <p>
            <strong>After Hours:</strong> 1-866-553-7205
          </p>
        </Col>
        <Col md={6}>
          <iframe
            title="map"
            src="https://maps.google.com/maps?q=358%20Oxford%20Street%20East%20London%20ON&t=&z=13&ie=UTF8&iwloc=&output=embed"
            width="100%"
            height="250"
            style={{ border: 0, borderRadius: "10px" }}
          />
        </Col>
      </Row>
    </Container>
  );
}

function PatientForm() {
  const formUrl = "/forms/patient-registration.pdf";
  return (
    <section id="patient_forms" className="patient-forms text-center py-5">
      <h2>Accepting new patients</h2>
      <p>Please complete the form below. Drop at clinic or mail in.</p>
      <Button as="a" style={styles.button} href={formUrl} download={formUrl}>
        Download Patient Registration Form
      </Button>
    </section>
  );
}
function Footer() {
  return (
    <div className="text-center py-5" style={{ background: "rgba(0,0,0,0.6)" }}>
      <p className="mb-0">
        © {new Date().getFullYear()} Colborne Medicare - Family Medicine Clinic.
      </p>
    </div>
  );
}

styles.card = {
  background: "rgba(255,255,255,0.1)",
  backdropFilter: "blur(10px)",
  borderRadius: "15px",
  color: "white",
  border: "none",
};

styles.button = {
  background: "linear-gradient(45deg, #0d6efd, #00c6ff)",
  border: "none",
  padding: "10px 20px",
  borderRadius: "30px",
  marginTop: "10px",
};

styles.qrBox = {
  background: "white",
  padding: "15px",
  display: "inline-block",
  borderRadius: "12px",
  marginBottom: "15px",
};
